import { CvDateFormatter, DATEFORMAT } from "@cv-invision/cv.component-library.ux";
import { DEFAULT_LOG_DETAIL } from "./default-callback-logs-columns.model";

export class CONNEXIONS_LOG_DETAIL extends DEFAULT_LOG_DETAIL {

	constructor(source: {name: string; field: string;}, public dateService: CvDateFormatter) {
		super(source, dateService);

		this.columns.splice(5, 0, {
			headerName: 'Order Response Date',
			field: 'orderResponseDate',
			width: 160,
			valueFormatter: params => dateService.format(DATEFORMAT.EMPTY, params.data.orderResponseDate)
		});
		this.columns.splice(5, 0, {
			headerName: 'Order API Response Date',
			field: 'orderApiResponseDate',
			width: 160,
			valueFormatter: params => dateService.format(DATEFORMAT.EMPTY, params.data.orderApiResponseDate)
		});
		this.columns.splice(4, 0, {
			headerName: 'Connexion Service ID',
			field: 'connexionsServiceId',
			width: 150
		});
    }
}
